import React, { FC } from 'react';
import { Loading } from '@minecraft.loader';
import { useHistory } from 'react-router-dom';
import { setAccessToken, setOnboardingToken, setRefreshToken, useRedirectByRole } from '@blocs.auth';
import AuthLayout from 'src/layout/AuthLayout';
import { getEnv } from 'utils/env';
import { ONBOARDING_URL } from 'config/constants/env';

const ProxyLoginPage: FC = () => {
  const routerHistory = useHistory();
  const [b21Token, setB21Token] = React.useState(null);
  const queryParams = new URLSearchParams(routerHistory.location.search);
  const accessToken = queryParams.get('accessToken');
  const refreshToken = queryParams.get('refreshToken');
  const loginType = queryParams.get('loginType');
  const userName = queryParams.get('userName');
  const onboardingUrl = getEnv(ONBOARDING_URL);

  if (loginType === 'B21') {
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
    setB21Token({ access: accessToken, refresh: refreshToken });
  } else if (loginType === 'Onboarding') {
    setOnboardingToken(accessToken);
    window.location.replace(`${onboardingUrl}/onboarding?username=${userName}`);
  }

  useRedirectByRole(b21Token as { access: string; refresh: string });

  return (
    <AuthLayout>
      <Loading />
    </AuthLayout>
  );
};

export default ProxyLoginPage;
